import { useMutation } from '@tanstack/react-query'

import { updateOrganizationInfo } from '@src/api'
import { DefaultApiUpdateOrganizationRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useUpdateOrganizationInfo = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateOrganizationRequest) =>
      updateOrganizationInfo(axiosInstance, params),
  })
}
